module.exports = __webpack_public_path__ + "static/images/two.87d6c03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/two.png
// module id = /4/x
// module chunks = 0